/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetSubjectProductSessionsR200ResponseInnerMetadataOneOfContentsFromJSON, GetSubjectProductSessionsR200ResponseInnerMetadataOneOfContentsToJSON, } from './GetSubjectProductSessionsR200ResponseInnerMetadataOneOfContents';
/**
 * @export
 */
export const GetSubjectProductSessionsR200ResponseInnerMetadataOneOfTagEnum = {
    TpMathIbls: 'tp_math_ibls'
};
/**
 * Check if a given object implements the GetSubjectProductSessionsR200ResponseInnerMetadataOneOf interface.
 */
export function instanceOfGetSubjectProductSessionsR200ResponseInnerMetadataOneOf(value) {
    if (!('contents' in value) || value['contents'] === undefined)
        return false;
    if (!('tag' in value) || value['tag'] === undefined)
        return false;
    return true;
}
export function GetSubjectProductSessionsR200ResponseInnerMetadataOneOfFromJSON(json) {
    return GetSubjectProductSessionsR200ResponseInnerMetadataOneOfFromJSONTyped(json, false);
}
export function GetSubjectProductSessionsR200ResponseInnerMetadataOneOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contents': GetSubjectProductSessionsR200ResponseInnerMetadataOneOfContentsFromJSON(json['contents']),
        'tag': json['tag'],
    };
}
export function GetSubjectProductSessionsR200ResponseInnerMetadataOneOfToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'contents': GetSubjectProductSessionsR200ResponseInnerMetadataOneOfContentsToJSON(value['contents']),
        'tag': value['tag'],
    };
}
